/** Écrans du plugin Studio, par chemin. Contrat : horaliia `frontend/src/App.tsx` (PLUGIN_ELEMENTS). */
import { StudioPage } from './StudioPage';

export const elements = {
  '/admin/studio': <StudioPage />,
};
